import { Link as baseLink } from 'react-router-dom';
import { styled } from '@this/constants/themes';
import { ButtonBase } from '@this/components/shared/atoms/button';

const LinkButton = styled(baseLink)`
  ${ButtonBase}
`;

export default LinkButton;
